import * as types from './actionTypes';
import axios from 'axios';

export const store_faqs = data => ({
  type: types.STORE_FAQS,
  payload: {
    faqs: data.faqs,
  }
});

export const sending_request = data => ({
  type: types.SENDING_REQUEST,
  payload: {
    loading: true,
  }
});
export const faqs_request_data = data => ({
  type: types.FAQS_REQUEST_DATA,
  payload: {
    faqs: data.data,
    loading: false,
  }
});

export const faqs_servicios_data = data => ({
  type: types.FAQS_SERVICIOS_CP,
  payload: {
    faqs_servicios: data.data,
    loading: false
  }
});

export const faqs_problems_data = data => ({
  type: types.FAQS_PROBLEMAS,
  payload: {
    faqs_problems: data.data,
    loading: false
  }
});

export const faqs_instructions_data = data => ({
  type: types.FAQS_INSTRUCCIONES,
  payload: {
    faqs_instructions: data.data,
    loading: false
  }
});

export const faqs_seguridad_data = data => ({
  type: types.FAQS_SEGURIDAD,
  payload: {
    faqs_seguridad: data.data,
    loading: false
  }
});

export const request_error = error => ({
  type: types.REQUEST_ERROR,
  payload: {
    error: error,
    loading: false
  }
});

const urlFaqsProd = 'https://mx.claropay.com/portal-claro-pay';
const urlFaqsUat = 'https://claropay-uat-uti.s3.us-west-2.amazonaws.com/faqs';
const urlFaqs = window.location.hostname === 'mx.claropay.com'? urlFaqsProd : urlFaqsUat;

const getData = (url) => {
  return axios
    // .get('https://claropay-prd-uti.s3-us-west-2.amazonaws.com/faqs.json')
    // .get('https://www.claropay.com/portal-claro-pay/faqs.json')
    // .get('http://127.0.0.1:5500/src/assets/json/faqs.json')
    .get(url)
    .then(res => res)
    .catch(error => error);
}

export const fetchData = () => dispatch => {
  dispatch(sending_request());
  return getData(`${urlFaqs}/faqs.json`)
    .then(data => {
      dispatch(faqs_request_data(data));
    })
    .catch(error => {
      dispatch(request_error(error));
    });
}

export const fetchFaqsServicios = () => dispatch => {
  
  dispatch(sending_request());
  return getData(`${urlFaqs}/faqs_servicios.json`)
    .then(data => {
      dispatch(faqs_servicios_data(data));
    })
    .catch(error => {
      dispatch(request_error(error))
    })
}

export const fetchFaqsProblems = () => dispatch => {
  dispatch(sending_request());
  return getData(`${urlFaqs}/faqs_problemas.json`)
    .then(data => {
      dispatch(faqs_problems_data(data));
    })
    .catch(error => {
      dispatch(request_error(error))
    });
}

export const fetchFaqsInstructions = () => dispatch => {
  dispatch(sending_request());
  return getData(`${urlFaqs}/faqs_instrucciones.json`)
    .then(data => {
      dispatch(faqs_instructions_data(data));
    })
    .catch(error => {
      dispatch(request_error(error))
    });
}

export const fetchFaqsSecurity = () => dispatch => {
  dispatch(sending_request());
  return getData(`${urlFaqs}/faqs_seguridad.json`)
    .then(data => {
      dispatch(faqs_seguridad_data(data));
    })
    .catch(error => {
      dispatch(request_error(error))
    });
}

/**
 * Commerces
 */

export const store_commerces = data => {
  return ({
    type: types.STORE_COMERCES,
    payload: {
      commerces: data,
      loading: false,
    }
  })
};

export const sendSearch = (data) => dispatch => {
  dispatch(sending_request());
  store_commerces(data);
}

